import React, { Component } from "react";
import { config } from "../../../config";
import { ApiVersion } from "../../Shared/AppConstants";
import { GlobalProps } from "../../../HelperMethods";
import { ILoginState } from "../Login/ILoginState";
import auth from "../../Auth";
import { createBrowserHistory } from "history";

export class ExternalLogin extends Component<GlobalProps, ILoginState>  {
    constructor(props) {
        super(props);
        const clientName = this.props.match.params[0];
        var provider = config.externalAccountsProviders[clientName];
        localStorage.setItem("provider", provider);
        if (auth.isAuthenticated()) {
            const history = createBrowserHistory();
            history.push('/');
        } else {
            window.location.href = `${config.baseURL}/api/${ApiVersion.DEFAULT}/accounts/login?provider=` + provider;
        }
    }

    componentDidMount() {

    }


    render() {
        return (
            <div>
            </div>
        );
    }
}

